import config from '@config'

import { GET_MINIREPORT, GET_MINIREPORT_REQUEST } from './constants'

export function getMinireport(entId) {
    return {
        type: GET_MINIREPORT,
        data: {
            entId,
        },
    }
}

export function getMinireportRequest(entId, lang, module) {
    return {
        type: GET_MINIREPORT_REQUEST,
        data: {
            entId,
        },
        payload: {
            ...config.api.minireport,
            qs: {
                module,
                lang,
            },
            uriParams: {
                entId,
            },
        },
    }
}
